import { Collapsible } from '../interfaces';
import { PliValue } from './pli-value';

export class CollapsiblePliValues implements Collapsible {
  collapsed = true;
  values: PliValue[];
}
